/*
 * auth (context)
 */
import type { Session, User } from "@supabase/supabase-js"
import type { UserRole } from "@psychology/types"
import { createContext } from "react"

type AuthState = {
	session: Session | null
	user: User | null
	role: UserRole
	isLoading: boolean
	signOut: () => Promise<void>
	refreshSession: () => Promise<void>
}

const initialState: AuthState = {
	session: null,
	user: null,
	role: "guest",
	isLoading: true,
	signOut: async () => undefined,
	refreshSession: async () => undefined,
}

export const AuthContext = createContext<AuthState>(initialState)
